module.exports = __webpack_public_path__ + "static/media/MembersIconActive.6b063157.png";